import React, { useContext, useState } from 'react';
import { chakra, Box, Text, VStack, Image, Flex, HStack, Button, ModalOverlay, ModalContent, Modal } from '@chakra-ui/react';
import { useLocation, useNavigate } from 'react-router-dom';
import Contact from '../../../../../images/ClinicoIcon.svg';
import { BsFillArrowLeftCircleFill } from 'react-icons/bs';
import { AccountContext } from 'components/AccountContext';
import BackButton from '../../../../../images/assets/telemedicina/backbutton.svg';
import TelemedDeslogado from '../../../../../../src/images/Deslogado/telemedDeslogado.svg';
import LogoDashboard from '../../../../../../src/images/petalas-deovita.svg';
function AvisoPreAtendimento2() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { user } = useContext(AccountContext);

  let usuarioAssinante = user.id_contrato && user.descricao_plano ? true : false;
  if (user.titular === false) usuarioAssinante = true;
  const [aviso, setAviso] = useState(false);

  const modalAviso = () => {
    return (
      <>
        <Modal isOpen={aviso} onClose={() => setAviso(false)} isCentered>
          <ModalOverlay />
          <ModalContent
            maxW="370px"
            w="90%"
            p={0}
            borderRadius="1.2em"
            boxShadow="0 4px 24px rgba(90,178,174,0.15)"
            display="flex"
            alignItems="center"
            justifyContent="center"
            bg={'#5AB2AE'}
          >
            <VStack bg="white" p={6} borderRadius="1.2em" spacing={5} w="100%" align="center">
              <HStack w="100%" bg="#FFF8E1" borderLeft="5px solid #FFB300" borderRadius="0.7em" p={3} spacing={2} align="flex-start" boxShadow="sm">
                <Image src="https://cdn-icons-png.flaticon.com/512/1828/1828843.png" alt="Aviso" boxSize="1.5em" mt={0.5} />
                <VStack align="start" spacing={0}>
                  <Text color="#B8860B" fontWeight="bold" fontSize="1em" mb={0}>
                    Atenção
                  </Text>
                  <Text color="#B8860B" fontSize="0.98em" lineHeight={1.3}>
                    Em caso de dúvidas, informações erradas em seus documentos prescritos pelos profissionais (médicos, psicólogos e nutricionistas)
                    ou problemas técnicos, entre em contato imediato com o suporte.
                  </Text>
                </VStack>
              </HStack>
              <Button
                bg={usuarioAssinante ? '#5AB2AE' : '#5AB2AE'}
                color="#FFFFFF"
                w="100%"
                borderRadius="0.8em"
                h="2em"
                fontWeight="bold"
                fontSize="1em"
                mt={2}
                onClick={() => {
                  if (user.termoTelemed) {
                    navigate(`${state?.tela}`, {
                      state: {
                        pediatra: state?.pediatra,
                        pago: state.pago,
                        credito: state?.credito,
                        metadataCoparticipacao: state?.metadataCoparticipacao,
                      },
                    });
                  } else {
                    navigate('/termos-de-uso/', {
                      state: {
                        pediatra: state?.pediatra,
                        tela: state?.tela,
                        pago: state.pago,
                        credito: state?.credito,
                        metadataCoparticipacao: state?.metadataCoparticipacao,
                      },
                    });
                  }
                }}
              >
                Entendi
              </Button>
            </VStack>
          </ModalContent>
        </Modal>
      </>
    );
  };

  return (
    <>
      <VStack
        align="center"
        wrap="no-wrap"
        minH="100vh"
        spacing={0}
        pt="6em"
        pb="6em"
        background={usuarioAssinante ? '#5AB2AE' : '#5AB2AE'}
        color="#585858"
        overflow="hidden"
      >
        <Image top="2.5em" left="1.3em" zIndex="9999" position="absolute" src={BackButton} onClick={() => navigate(-1)} />
        <Box as="card" width="328px" borderRadius="18px" fontSize="xs" size="10" backgroundColor="white" maxInlineSize="80" textAlign="center">
          <VStack m={{ sm: '10%' }} textColor="#585858">
            <Image top={{ lg: '5.5em', sm: '5em' }} src={!usuarioAssinante ? TelemedDeslogado : Contact} alt="teste" height={'4.5em'} />
            <Text fontWeight="bold" fontSize="1.5em">
              Orientações do {state.titulo ? state.titulo : 'Pronto Atendimento'}
            </Text>
            <HStack backgroundColor="#E5E5E5" borderRadius="15px">
              <Text>
                <Flex ml="1em">
                  <Box
                    backgroundColor={usuarioAssinante ? '#5AB2AE' : '#5AB2AE'}
                    borderRadius="5px"
                    margin="0.8em"
                    color="rgba(62, 100, 255, 1)"
                    padding="0 0.4em"
                  ></Box>
                  <Text p={'5'} fontSize="xs" align="left" color="#585858;">
                    <chakra.p>
                      Em casos <b>emergenciais</b> e <b>urgências</b>, é recomendado tratamento médico presencial imediato;
                    </chakra.p>
                  </Text>
                </Flex>
                <Flex ml="1em">
                  <Box
                    backgroundColor={usuarioAssinante ? '#5AB2AE' : '#5AB2AE'}
                    borderRadius="5px"
                    margin="0.8em"
                    color="rgba(62, 100, 255, 1)"
                    padding="0 0.4em"
                  ></Box>
                  <Text p={'5'} fontSize="xs" align="left" color="#585858;">
                    <chakra.p>Esteja em ambiente calmo e silencioso, para maior conforto durante a consulta;</chakra.p>
                  </Text>
                </Flex>
                <Flex ml="1em">
                  <Box
                    backgroundColor={usuarioAssinante ? '#5AB2AE' : '#5AB2AE'}
                    borderRadius="5px"
                    margin="0.8em"
                    color="rgba(62, 100, 255, 1)"
                    padding="0 0.4em"
                  ></Box>
                  <Text p={'5'} fontSize="xs" align="left" color="#585858;">
                    <chakra.p>
                      Para a sua <b>segurança</b>, seu atendimento será <b>gravado</b>.
                    </chakra.p>
                  </Text>
                </Flex>
                <div
                  style={{
                    width: '10px',
                    height: '10px',
                    borderRadius: '50%',
                    backgroundColor: '#D9D9D9',
                    display: 'inline-block',
                  }}
                ></div>
                <div
                  style={{
                    width: '10px',
                    height: '10px',
                    borderRadius: '50%',
                    backgroundColor: usuarioAssinante ? '#5AB2AE' : '#5AB2AE',
                    display: 'inline-block',
                  }}
                ></div>
                <VStack w="100%" p={'1em'} ml={'40%'}>
                  <BsFillArrowLeftCircleFill size={'2em'} color={usuarioAssinante ? '#5AB2AE' : '#5AB2AE'} onClick={() => navigate(-1)} />
                </VStack>
              </Text>
            </HStack>

            <VStack w="100%" p="1em" ml="40%">
              <VStack alignItems="left" w="100%">
                <Button
                  bg={usuarioAssinante ? '#5AB2AE' : '#5AB2AE'}
                  color="#FFFFFF"
                  w="100%"
                  onClick={() => {
                    setAviso(true);
                    return;
                    if (user.termoTelemed) {
                      navigate(`${state?.tela}`, {
                        state: {
                          pediatra: state?.pediatra,
                          pago: state.pago,
                          credito: state?.credito,
                          metadataCoparticipacao: state?.metadataCoparticipacao,
                        },
                      });
                    } else {
                      navigate('/termos-de-uso/', {
                        state: {
                          pediatra: state?.pediatra,
                          tela: state?.tela,
                          pago: state.pago,
                          credito: state?.credito,
                          metadataCoparticipacao: state?.metadataCoparticipacao,
                        },
                      });
                    }
                  }}
                  borderRadius="0.8em"
                  h="2em"
                >
                  Entendi
                </Button>
              </VStack>
            </VStack>
          </VStack>
        </Box>
        {modalAviso()}
      </VStack>
    </>
  );
}

export default AvisoPreAtendimento2;
